<template>
  <v-row class="ma-0 pa-0 justify-center" dense>
    <v-col class="mx-auto cts-view-header">
      <v-row class="cts-breadcrumbs ma-0 mt-1 pa-0" dense>
        <a
          test-id="link-list-transactions"
          :title="$vuetify.lang.t('$vuetify.allTransactions')"
          @click.prevent="emitEvent('backToMenu')"
        >
          {{ $vuetify.lang.t("$vuetify.transactions") }}
        </a>
        <span
          test-id="link-transaction-details"
          class="cts-color-black_soft_text font-weight-regular ml-1"
          >/
          {{ $vuetify.lang.t("$vuetify.transactionDetails") }}
        </span>
      </v-row>
      <view-title
        :icon="const_icons.TRANSACTION"
        :right-link="{
          text: $vuetify.lang.t('$vuetify.refresh'),
          icon: 'refresh',
          event: 'refresh',
        }"
        :subtitle="`${
          transaction_content?.translated_process_name
        } | ${$vuetify.lang.t(
          '$vuetify.transactionId'
        )}: ${transaction_content?.transaction_id.split('.').pop()}`"
        :title="
          transactionStatus.id !== 'invalid' &&
          transaction_content?.process_name !==
            transaction_content?.transaction_name
            ? transaction_content?.transaction_name
            : $vuetify.lang.t('$vuetify.transactionDetails')
        "
        idName="transaction-detail"
        @refresh="getTransactionData()"
      />
    </v-col>
  </v-row>
</template>

<script>
import viewTitle from "@/components/structures/viewTitle.vue";
import const_icons from "@/constants/icons";
export default {
  name: "TransactionDetailHeaderSection",
  components: {
    viewTitle,
  },
  props: {
    getTransactionData: Function,
    transaction_content: Object,
    transactionStatus: Object,
  },
  data() {
    return {
      const_icons,
    };
  },
  methods: {
    emitEvent(event) {
      this.$emit(event);
    },
  },
};
</script>

<style lang="scss" scoped>
  @media (max-width: 435px) {
  .cts-view-header {
    width: 100% !important;
    min-width: 300px;
    max-width: 425px;
    padding-left: 30px;
   
}
 ::v-deep(.cts-view-subtitle) {
    font-size: 10px !important;
  }
  }
  @media (max-width:320px) {
    .cts-view-header {
    padding-left: 60px;
   
}
  }
</style>
